export default __webpack_public_path__ + "static/media/edit.9e4757ed.svg";